(function ($, Drupal, once) {
  'use strict';
  Drupal.behaviors.dlaDineLALanding = {
    attach: function attach(context, settings) {
      var self = this;
      var isMobile = false; //initiate as false
      // device detection
      if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(navigator.userAgent)
        || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(navigator.userAgent.substr(0,4))
        || $(window).width() <= 768
      ) {
        isMobile = true;
      }

      // When working with AJAX-enabled Views that are initially filtered by URL parameters
      // but we want to remove those parameters after the first load (without page reload)
      // the ideal approach is to:
      // 1) Use the window.history.replaceState() method in JavaScript after the AJAX view is initially rendered
      // to remove the query parameters from the URL, thereby ensuring:
      // 2) The view is initially filtered using URL parameters.
      // 3) Once the view is loaded, the URL is cleaned.
      // 4) Further AJAX filtering isn't affected by the initial URL parameters.
      // Do not run this function when path is "/dinela/filters" since that path is for generating url filter parameters,
      // and we want those params to stay in the url
      if (window.location.pathname !== '/dinela/filters') {
        once('clean-view-url-params', 'body', context).forEach(function () {
          const paramsToRemove = [
            'combine',
            'field_neighborhood_target_id[]',
            'field_region_target_id[]',
            'field_cuisine_target_id[]',
            'field_neighborhood_target_id%5B0%5D',
            'field_region_target_id%5B0%5D',
            'field_cuisine_target_id%5B0%5D',
            'field_open_table_id_value',
            'field_michelin_restaurant_value',
            'field_michelin_restaurant',
            'field_dining_options_value[]',
            'field_price_custom[]',
            'field_lunch_price_value[]',
            'field_dinner_price_value[]',
            'field_dining_options_value%5B0%5D',
            'field_price_custom%5B0%5D',
            'field_lunch_price_value%5B0%5D',
            'field_dinner_price_value%5B0%5D',
            'field_dining_options_value%5B0%5D',
            'field_price_custom%5B0%5D',
            'field_lunch_price_value%5B0%5D',
            'field_dinner_price_value%5B0%5D'
          ]; // List all expected filter parameters
          const url = new URL(window.location.href);
          let modified = false;
          paramsToRemove.forEach(param => {
            if (url.searchParams.has(param)) {
              url.searchParams.delete(param);
              modified = true;
            }
          });
          if (modified) {
            // Replace URL without reloading
            window.history.replaceState({}, document.title, url.pathname + url.search);
          }
        });
      }

      // Run menu notification function
      // self.menuNotify();

      // Set up some display conditions for elements in top nav
      // The function of the top nav elements differs based on mobile or desktop
      if (isMobile) {
        var map_toggle_top = 65 + $("#toolbar-administration").height();
        // Move the map toggle to outside of .view__header
        $(".dla-map-toggle-wrapper").detach().appendTo(".view__footer").addClass("dinela-sticky-map-toggle").css("top", map_toggle_top +"px");
        // Hide filters initially
        $(".view-dinela .view__header").hide();
        // Ensure labels for select dropdown can be seen by removing class "visually-hidden"
        $('.view-dinela .view__header .js-form-type-select label').removeClass('visually-hidden');
        $('.view-dinela .view__header .form-item--type-textfield label').addClass('visually-hidden');
        // Ensure search icon is displayed for mobile
        // It is set to be hidden for dinela pages but we will repurpose this icon to activate and hide filter
        // $('.search_icon').css({"display": "flex", "justify-content": "end"});
        $('.search_icon').css('visibility', 'visible');
        // Repurpose search icon to activate and hide filter
        $('#la_search', context).on('click', function() {
          $(".view-dinela .view__header").addClass("sticky").show();
          $('.dla-navbar_container').removeClass('search_open');
          $(this).hide();
          //** $('.dla-region-header, .dla-tabs__nav_button, .dla-region-tabs, .paragraph--type--carousel, .paragraph--type--feature, .newsletter-signup, .site-footer').hide();
          $('#la_close_search').show();
        });

        $('#la_close_search', context).on('click', function() {
          $(".view-dinela .view__header").removeClass("sticky").hide();
          $('.dla-navbar_container').removeClass('search_open');
          $(this).hide();
          // $('.dla-region-header, .dla-tabs__nav_button, .dla-region-tabs, .paragraph--type--carousel, .paragraph--type--feature, .newsletter-signup, .site-footer').show();
          //** $('.dla-region-header, .dla-tabs__nav_button, .paragraph--type--carousel, .paragraph--type--feature, .newsletter-signup, .site-footer').show();
          // Adjustment to ensure tab arrow down button reamain hidden
          //$('.dla-region-header, .dla-region-tabs, .paragraph--type--carousel, .paragraph--type--feature, .newsletter-signup, .site-footer').show();
          $('#la_search').show();
        });

        // Adding function for mobile that closes filters when map/list toggle is clicked
        $('.dla-map-toggle__btn', context).on('click', function() {
          $('#la_close_search').trigger( "click" );
        });

        // Remove sticky table header
        $('table.sticky-header').remove();

      } else {
        // If we are on a Desktop device

        // then we will always hide search icon and forms
        $('.search_icon').css("display", "none");
        $('.search_form').css("visibility", "hidden");

        // Ensure labels for select dropdown is hidden but still visible to screen readers by adding the class "visually-hidden"
        // Add :not for certain elements to make exceptions to ensure we can still see their labels
        $('.view-dinela .view__header label:not(#label-edit-field-favorites):not(.option)').addClass('visually-hidden');

        // Dine LA. takeout adjustments
        // set width of chosen dropdowns to 100%
        $('.view__filters__wrapper .chosen-container').css('width', '100%');
        $( window ).resize(function() {
          $('.view__filters__wrapper .chosen-container').css('width', '100%');
        });
      }

      // Move the "all" option the following dropdowns since we are using multiple select with chosen wrapper
      $('select[name="field_neighborhood_target_id[]"] option[value=All]').remove();
      $('select[name="field_cuisine_target_id[]"] option[value=All]').remove();
      $('select[name="field_price_custom[]"] option[value=All]').remove();

      // When "My Favorites" checkbox is checked, select "true" value
      // in the hidden Flagged field in order to filter listings that are favorited
      $('.form-item--name-flagged').hide();
      $('[data-drupal-selector="edit-field-favorites"]').change(function(){

        if ($(this).is(':checked') == true) {
          $('[data-drupal-selector="edit-flagged"]').val(1).attr("selected", "selected");
        } else {
          $('[data-drupal-selector="edit-flagged"]').val('All').attr("selected", "selected");
        }

        if ($(this).hasClass('checked')) {
          $(this).removeClass('checked');
        } else {
          $(this).addClass('checked');
        }

      });

      // Customization for favorite filter
      // $('label[id^="label-edit-field-favorites"]').on('click', function(e) {
      //
      //   $('[data-drupal-selector="edit-field-favorites"]').trigger("click");
      // });

      // if (isMobile && $('.search_icon').find('#label-edit-field-favorites').length === 0) {
      //   // Move favorite filter filter icon when on mobile
      //   $('label[id^="label-edit-field-favorites"]').find('span').hide();
      //   $('label[id^="label-edit-field-favorites"]').insertBefore('#la_search');
      // }


      // Hide lunch and dinner price filters since we will be using the custom price filter to control those filters behind the scenes.
      $('.form-item--name-field-lunch-price-value, .form-item--name-field-dinner-price-value').hide();
      // Grab all options in each field - .form-item--name-field-lunch-price-value and .form-item--name-field-dinner-price-value
      var lunch_options = [];
      $('.form-item--name-field-lunch-price-value option').each(function() {
        lunch_options.push($(this).val());
      });
      var dinner_options = [];
      $('.form-item--name-field-dinner-price-value option').each(function() {
        dinner_options.push($(this).val());
      });

      // Set chosen type for custom price field
      $('select[data-drupal-selector="edit-field-price-custom"]').chosen();
      $('select[data-drupal-selector="edit-field-price-custom"]').change(function(event, data){
        var i;
        var lunchArr = [];
        var dinnerArr = [];
        for (i = 0; i < $(this).val().length; i++) {
          // Apply special functions for when either "Lunch - All" or "Dinner - All" is selected
          if ($(this).val()[i] === "Lunch - All" || $(this).val()[i] === "Dinner - All") {
            // If "Lunch - All" was selected, populate lunchArr with all lunch price points
            if ($(this).val()[i] === "Lunch - All") {
              lunchArr = self.arrayUnique(lunchArr.concat(lunch_options));
            }
            // If "Dinner - All" was selected, populate dinnerArr with all dinner price points
            if ($(this).val()[i] === "Dinner - All") {
              dinnerArr = self.arrayUnique(dinnerArr.concat(dinner_options));
            }
          } else {
            if ($(this).val()[i].indexOf("Lunch ") >= 0) {
              lunchArr.push($(this).val()[i].replace("Lunch ", ""));
            }
            if ($(this).val()[i].indexOf("Dinner ") >= 0) {
              dinnerArr.push($(this).val()[i].replace("Dinner ", ""));
            }
          }
          // if ($(this).val()[i].indexOf("Lunch ") >= 0) {
          //   lunchArr.push($(this).val()[i].replace("Lunch ", ""));
          // }
          // if ($(this).val()[i].indexOf("Dinner ") >= 0) {
          //   dinnerArr.push($(this).val()[i].replace("Dinner ", ""));
          // }
        }

        $('[data-drupal-selector="edit-field-lunch-price-value"]').val(lunchArr);
        $('[data-drupal-selector="edit-field-dinner-price-value"]').val(dinnerArr);
      });

      // Hide OpenTable, Grubhub, Pet Friendly and Michelin Restaurant fields coming from views.
      $('.form-item--name-field-open-table-id-value, .form-item--name-field-grubhub-url-uri, .form-item--name-field-pet-friendly-value, .form-item--name-field-michelin-restaurant-value').hide();
      // Hide Custom filter for  Off-Site Dining
      //*** $('.form-item--name-field-dining-options-value-1').hide();
      // Set value of hidden field_open_table_id_value field when custom OpenTable field is checked
      $('[data-drupal-selector="edit-field-opentable"]').change(function(){
        if ($(this).is(':checked') == true) {
          $('.form-item--name-field-open-table-id-value').find('[data-drupal-selector="edit-field-open-table-id-value"]').val('1');
          // Special logic, only include OpenTable restaurants that have Dine-In
          //$('select[data-drupal-selector="edit-field-dining-options-value"]').val('Dine-In');
          // Special logic, only include OpenTable restaurants that have Outdoor Dining
          //$('select[data-drupal-selector="edit-field-dining-options-value"]').val('Outdoor Dining');

          //***bao*** var selectedDiningOptions = new Array();
          //***bao*** $('select[data-drupal-selector="edit-field-dining-options-value"] option:selected').each(function() {
          //***bao*** selectedDiningOptions.push(this.value);
          //***bao*** });
          // Select dining options Dine-In if Outdoor Dining has not been selected yet
          //***bao*** if ($.inArray( "Outdoor Dining", selectedDiningOptions ) == -1) {
          //***bao*** $("select option[value='Dine-In']").prop("selected", true);
          //***bao*** }
          // Select dining options Outdoor Dining
          //***bao*** $("select option[value='Outdoor Dining']").prop("selected", true);
          //***bao*** $('select[data-drupal-selector="edit-field-dining-options-value"]').trigger('chosen:updated');
          // Special logic, only include Grubhub restaurants that include Off-site Dining
          //***bao*** $('select[data-drupal-selector="edit-field-dining-options-value-1"]').val('2');
        } else {
          $('.form-item--name-field-open-table-id-value').find('[data-drupal-selector="edit-field-open-table-id-value"]').val('All');
          // Deselect dining options Dine-In
          //***bao*** $("select option[value='Dine-In']").prop("selected", false);
          // Deselect dining options Outdoor Dining
          //***bao*** $("select option[value='Outdoor Dining']").prop("selected", false);
          //***bao*** $('select[data-drupal-selector="edit-field-dining-options-value"]').trigger('chosen:updated');
          // Deselect dining options Dine-In
          //*** $("select option[value='2']").prop("selected", false);
          //*** $('select[data-drupal-selector="edit-field-dining-options-value-1"]').trigger('chosen:updated');
        }
      });
      // Set value of hidden field_grubhub_id_value field when custom Grubhub field is checked
      $('[data-drupal-selector="edit-field-grubhub"]').change(function(){
        if ($(this).is(':checked') == true) {
          $('.form-item--name-field-grubhub-url-uri').find('[data-drupal-selector="edit-field-grubhub-url-uri"]').val('1');
          // Special logic, only include Grubhub restaurants that have 'Take-Out', 'Delivery'
          $('select[data-drupal-selector="edit-field-dining-options-value"]').val(['Take-Out', 'Delivery']);
          // Special logic, only include Grubhub restaurants that include Off-site Dining
          //*** $('select[data-drupal-selector="edit-field-dining-options-value-1"]').val('1');
        } else {
          $('.form-item--name-field-grubhub-url-uri').find('[data-drupal-selector="edit-field-grubhub-url-uri"]').val('All');
          $("select option[value='Take-Out']").prop("selected", false);
          $("select option[value='Delivery']").prop("selected", false);
          $('select[data-drupal-selector="edit-field-dining-options-value"]').trigger('chosen:updated');
          // Deselect dining options Off-Site Dining
          //*** $("select option[value='1']").prop("selected", false);
          //*** $('select[data-drupal-selector="edit-field-dining-options-value-1"]').trigger('chosen:updated');
        }
      });
      // Set value of hidden field_pet_friendly_value field when custom Pet Friendly field is checked
      $('[data-drupal-selector="edit-field-pet-friendly"]').change(function(){
        if ($(this).is(':checked') == true) {
          $('.form-item--name-field-pet-friendly-value').find('[data-drupal-selector="edit-field-pet-friendly-value"]').val('1');
        } else {
          $('.form-item--name-field-pet-friendly-value').find('[data-drupal-selector="edit-field-pet-friendly-value"]').val('All');
        }
      });
      // Set value of hidden field_michelin_restaurant_value field when custom Michelin Restaurant field is checked
      $('[data-drupal-selector="edit-field-michelin-restaurant"]').change(function(){
        if ($(this).is(':checked') == true) {
          $('.form-item--name-field-michelin-restaurant-value').find('[data-drupal-selector="edit-field-michelin-restaurant-value"]').val('1');
        } else {
          $('.form-item--name-field-michelin-restaurant-value').find('[data-drupal-selector="edit-field-michelin-restaurant-value"]').val('All');
        }
      });

      // Add toggle function between two checkboxes
      $('[data-drupal-selector="edit-field-grubhub"]').change(function() {
        if ($(this).is(":checked")) {
          if ($('[data-drupal-selector="edit-field-opentable"]').is(":checked")) {
            $('[data-drupal-selector="edit-field-opentable"]').click();
          }
        }
      });
      $('[data-drupal-selector="edit-field-opentable"]').change(function() {
        if ($(this).is(":checked")) {
          if ($('[data-drupal-selector="edit-field-grubhub"]').is(":checked")) {
            $('[data-drupal-selector="edit-field-grubhub"]').click();
          }
        }
      });

      // $(document).once().ready(function (event) {
      $(once('dla-processed', 'html')).ready(function() {

        var targetScrollTop = self.targetScrollTop();
        var totalTopElements = self.totalTopElements();
        var offsetFilter = $(".view-dinela .view__header").offset();
        // height of current scroll that will make the filter sticky
        var stickyHeight = offsetFilter.top - totalTopElements;

        $(".table-header-placeholder .views-table").append($(".view-id-dinela .view__content .views-table thead"));

        //var offsetFilter = $(".view-dinela .view__header").offset();
        // height of current scroll that will make the filter sticky
        //var stickyHeight = offsetFilter.top - $("#dla-navbar").height();

        // Prepare for Chosen dropdown formatting for price dropdowns since that config is not available in the views
        //$('select[data-drupal-selector="edit-field-lunch-menu-price-value"]').attr("multiple", "multiple").find('option[value="All"]').removeAttr("selected");
        //$('select[data-drupal-selector="edit-field-dinner-menu-price-value"]').attr("multiple", "multiple").find('option[value="All"]').removeAttr("selected");
        // Apply Chosen dropdown formatting

        $('select[data-drupal-selector="edit-field-neighborhood-target-id"]').chosen();
        $('select[data-drupal-selector="edit-field-cuisine-target-id"]').chosen();
        $('select[data-drupal-selector="edit-field-lunch-price-value"]').chosen();
        $('select[data-drupal-selector="edit-field-dinner-price-value"]').chosen();
        $('select[data-drupal-selector="edit-field-dining-options-value"]').chosen();
        //*** $('select[data-drupal-selector="edit-field-dining-options-value-1"]').chosen();

        // Apply special formatting for chosen dropdown to limit height of selected elements for desktop users
        if (isMobile == false) {
          $('.view__filters__wrapper .form-item--type-select').mouseover(function() {
            $(this).css('overflow', 'visible');
          });
          $('.view__filters__wrapper .form-item--type-select').mouseout(function() {
            $(this).css('overflow', 'hidden');
          });
        }

        // Resets values in filter when Clear button is clicked
        $('input[id^=edit-reset]').on('click', function(e) {

          // clear select sessionStorage keys
          for (var keySession in sessionStorage) {
            if (keySession.indexOf('edit-field') !== -1) {
              sessionStorage.removeItem(keySession);
            }
          }

          e.preventDefault();

          $('.views-exposed-form .form-item--type-textfield input.form-text').val('');
          $('.views-exposed-form .form-select:not([multiple="multiple"])').val('All');

          // Deselect for Chosen dropdowns
          // $('.views-exposed-form .form-select[multiple="multiple"] option:selected').removeAttr('selected');
          $('.views-exposed-form .form-select[multiple="multiple"]').find('option').prop('selected', '');
          $('.views-exposed-form .form-select[multiple="multiple"]').trigger('chosen:updated');

          // Deselect checkboxes
          $('.views-exposed-form [type="checkbox"]'). prop("checked", false);

          // Submit form again once values are cleared to bring back default results
          $( ".views-exposed-form input[id^=edit-submit-dinela]" ).trigger( "click" );
        });

        // If auto submit is disabled, then we will use this element to trigger a submit on the form when clicked
        $('input[id^=edit-submit-custom]').on('click', function(e) {
          $( ".views-exposed-form input[id^=edit-submit-dinela]" ).trigger( "click" );
        });

        // Set up function to return true when item is in view, applies to table of listings
        $.fn.isInViewport = function () {
          var elementTop = $(this).offset().top;
          var elementBottom = elementTop + $(this).outerHeight();
          var viewportTop = $(window).scrollTop();
          var viewportBottom = viewportTop + $(window).height();
          return elementBottom > viewportTop && elementTop < viewportBottom;
        };

        // Initially hide feedbackify (show when table of listing is in view)
        // $('#feedbackify').hide();

        var previousScroll = 0;
        $(window).on('scroll', function () {

          var currentScroll = $(this).scrollTop();

          if (currentScroll > previousScroll) {
            // Direction Down
            // Make filter sticky once scrolled past required height
            // - for desktop only
            // - We not add class sticky after user just submitted filter to allow filter to be positioned correctly above results
            if (stickyHeight < currentScroll && isMobile == false) {
              // The class enteredSearch is a flag to detect whether or not user entered filter
              // We must only add the sticky class if this class enteredSearch is not present
              if (!$(".view-dinela .view__header").hasClass("enteredSearch")) {
                $(".view-dinela .view__header").addClass("sticky");
                // Insert table header as last element in filter
                var height_sticky_header = $(".view-dinela .view__header").height() + $("#dla-navbar").height() + $(".dla-region-header").height();
                $("table.sticky-header").css("top", height_sticky_header + "px");
                $("table.sticky-header").css("visibility", "visible");
              } else {
                // This means that the class enteredSearch was present and user was taken to top
                // And we did not add sticky class to allow for filter to be positioned correctly
                // But we must now remove the class enteredSearch to resume normal sticky function
                $(".view-dinela .view__header").removeClass("enteredSearch");
              }
            }

          } else {
            // Direction Up
          }

          // When on desktop, remove sticky from filter when scrolling all the way to the top so that it does not overlay rotator
          // Calculate the height of targetScrollTop before the view starts to ensure sticky class is removed at the correct scroll position
          if ($(this).scrollTop() <= targetScrollTop && isMobile == false) {
            $(".view-dinela .view__header").removeClass("sticky");
          }

          if (isMobile == true) {

            // remove sticky table headers for mobile
            $('table.sticky-header').remove();
            // $("table.sticky-header th.views-field-field-lunch-menu-price").css("display", "none");
            // $("table.sticky-header th.views-field-field-dinner-menu-price").css("display", "none");
            // $("table.sticky-header th.views-field-name").css("display", "none");
            // $("table.sticky-header th.views-field-name-1").css("display", "none");
            // $("table.sticky-header th.views-field-nothing-1").css("display", "none");
            // $("table.sticky-header th.views-field-field-dining-options").css("display", "none");
            // $("table.sticky-header th.views-field-title-1").css("display", "none");
            // $("table.sticky-header th.views-field-nothing").css("display", "none");
            // $("table.sticky-header th.views-field-nid-1").css("display", "none");
            // $("table.sticky-header th.views-field-field-booking-url").css("display", "none");
          }

          previousScroll = currentScroll;

          // Detect when table of listing is in view to make certain adjustments (show or hide feedbackify, table layout for mobile size)
          if ($('.view-id-dinela .views-table').isInViewport()) {
            if (isMobile == false) {
             $("table.sticky-header").show();
            }
            if (isMobile) {
              $("table.sticky-header").css("top", $("#dla-navbar").height() + "px");
              $("table.sticky-header th.views-field-field-lunch-menu-price").css("display", "none");
              $("table.sticky-header th.views-field-field-dinner-menu-price").css("display", "none");
              $("table.sticky-header th.views-field-name").css("display", "none");
              $("table.sticky-header th.views-field-name-1").css("display", "none");
              $("table.sticky-header th.views-field-title-1").css("display", "none");
            } else {
              $("table.sticky-header th.views-field-field-lunch-menu-price").css("display", "table-cell");
              $("table.sticky-header th.views-field-field-dinner-menu-price").css("display", "table-cell");
              $("table.sticky-header th.views-field-name").css("display", "table-cell");
              $("table.sticky-header th.views-field-name-1").css("display", "table-cell");
              $("table.sticky-header th.views-field-title-1").css("display", "table-cell");
            }
          } else {
            if (isMobile == false) {
              $("table.sticky-header").hide();
            }
          }
        });

      });

      // Hide the distance column initially since it only populates with values after form submit
      $('.view-dinela td[headers^=view-field-coordinates-proximity-table-column], .view-dinela th[id^=view-field-coordinates-proximity-table-column]').hide();

      // Remove ad row from table if there is no ad available
      // Note: this script may not be working properly and might remove the ad even when it exists
      // if ($(".dinela_ad iframe").length == 0) {
      //   $(".dinela_ad").remove();
      // }

      /* Views Ajax Content Load Autoscroll Feature Disabled */
      Drupal.AjaxCommands.prototype.viewsScrollTop = null;

      // Add some custom functions that fire whenever a user has submitted the filter form
      $(document).ajaxComplete(function(event, xhr, settings) {

        let params = new URLSearchParams(settings.extraData);
        let viewname = params.get("view_name");
        let sort = params.get("sort");
        let totalTopElements = self.totalTopElements();

        // Address special case for populating restaurant display field for menu notification webform.
        // Sometimes the form might still loading and restaurant display fields are unavailable until ajax complete command is done.
        // So we run the process again here grabbing the restaurant name from the .dla-webform-data-container which is populated
        // during the click function on the Notify Me button as specified in the function menuNotify
        if ($('#webform-56897').find('.dla-webform-data-container').attr('data-restaurant') && $('#webform-56897').find('.dla-webform-data-container').attr('data-restaurant-nid')) {
          $('[data-drupal-selector="edit-restaurant-display-name"]').val($('#webform-56897').find('.dla-webform-data-container').attr('data-restaurant'));
          $('[data-drupal-selector="edit-restaurant-nid"]').val($('#webform-56897').find('.dla-webform-data-container').attr('data-restaurant-nid'));
          // Calculate width of text for restaurant display name and set input field to that width to get it to be inline with its prefix on the form
          var textWidth = self.calcTextWidth($('[data-drupal-selector="edit-restaurant-display-name"]').val(), $('[data-drupal-selector="edit-restaurant-display-name"]').css('font-size'), $('[data-drupal-selector="edit-restaurant-display-name"]').css('font-family'));
          $('[data-drupal-selector="edit-restaurant-display-name"]').css('width', textWidth.width);
        };

        // Run the following only if the ajax submit came from the views exposed filter
        // since we have other forms (newsletter) on the page that also use the ajax event
        if (viewname == 'dinela') {

          //self.mapBoxInvalidateSize(context);

          // Calculate the combined height of all paragraph divs before the view starts
          //var totalHeight = $(".dla-paragraph-region-header").height() + totalTopElements;

          let lat = params.get("field_coordinates_proximity[source_configuration][origin][lat]");
          let lon = params.get("field_coordinates_proximity[source_configuration][origin][lon]");

          // Hide or show distance info and sort header if lat and lon have values
          if (lat && lon ) {
            if (isMobile) {
              $('.view-dinela .sticky-header').show();
            }
            $('.view-dinela td[headers^=view-field-coordinates-proximity-table-column], .view-dinela th[id^=view-field-coordinates-proximity-table-column]').show();
          } else {
            if (isMobile) {
              $('.view-dinela .sticky-header').hide();
            }
            $('.view-dinela td[headers^=view-field-coordinates-proximity-table-column], .view-dinela th[id^=view-field-coordinates-proximity-table-column]').hide();
          }

          if (settings.extraData) {
            let targetScrollTop = self.targetScrollTop();
            if (isMobile) {
              $('html, body').animate({scrollTop: targetScrollTop ? targetScrollTop : totalTopElements}, 100);
            } else {
              // Only apply scroll to top when viewing list and not map
              if ($('.dla-map-toggle__btn--list').css('display') == 'none') {
                $('html, body').animate({scrollTop: targetScrollTop ? targetScrollTop - $('.view-dinela .view__header').height() : totalTopElements}, 100);
              }
            }

            //$('html, body').animate({scrollTop: $('.paragraph--type--carousel').height()}, 100);
            // if ($('[role="contentinfo"].messages').length) {
            //   $('html, body').animate({scrollTop: $('.paragraph--type--carousel').height() + $('[role="contentinfo"].messages').height()}, 100);
            // } else {
            //   $('html, body').animate({scrollTop: $('.paragraph--type--carousel').height()}, 100);
            // }
          }
          $(".view-dinela .view__header").removeClass("sticky");
          $(".view-dinela .view__header").addClass("enteredSearch");

          // Hide close search icon
          $('#la_close_search').hide();
          $('#la_search').show();

          // $('html, body').once().animate({
          //   scrollTop: '1px'
          // }, 200);

          // Due to the recent addition of the chosen dropdowns for multi-select function, it sometimes hides the table headers after each selection
          // To address this, we nudge the window to scroll a little to activate window scroll event to get the table headers repositioned
          window.scrollBy(0, 2);

          // It seems that table sort events trigger the artificial vanity field checkbox "Favorites" to be checked
          // Ensure that field's checkbox state remains unaffected by ajax events that occur during table sort events
          // (for some reason table sort events make that checkbox checked)
          // To ensure the checkbox is not effected by such events, check the state of the
          // field that is hidden but is the true field ($('[data-drupal-selector="edit-flagged"]')) that passes the value to the filter
          if (sort !== null) {
            if ($('[data-drupal-selector="edit-flagged"]').children("option:selected").val() == '1') {
              $('[data-drupal-selector="edit-field-favorites"]'). prop("checked", true);
            } else {
              $('[data-drupal-selector="edit-field-favorites"]'). prop("checked", false);
            }
          }

          // If favorite filter is checked, ensure we add a class "checked to its label
          if (params.get("flagged") == 1) {
            $('label[id^="label-edit-field-favorites"]').addClass('checked');
          } else if (params.get("flagged") == "All") {
            $('label[id^="label-edit-field-favorites"]').removeClass('checked');
          }

          if (isMobile) {
            $('.dla-navbar_container').removeClass('search_open');
            // Ensure these elements show after every search
            //** $('.dla-region-header, .dla-tabs__nav_button, .paragraph--type--carousel, .paragraph--type--feature, .newsletter-signup, .site-footer').show();
            // $('.dla-region-header, .dla-tabs__nav_button, .dla-region-tabs, .paragraph--type--carousel, .paragraph--type--feature, .newsletter-signup, .site-footer').show();
            // Adjustment to ensure tab arrow down button remain hidden
            //$('.dla-region-header, .dla-region-tabs, .paragraph--type--carousel, .paragraph--type--feature, .newsletter-signup, .site-footer').show();
          }

        }

      });

    },

    menuNotify: function () {

      var self = this;

      $('#webform-56897').on('hidden.bs.modal', function () {
        $('#webform-56897 .js-webform-confirmation-back-link-ajax').trigger( "click" );
      });

      $('.dla-btn-menu-notify').each(function () {
        $(this).on('click', function(e) {

          // Display modal form for Dine LA Menu Notification

          if ($('#webform-56897 .js-webform-confirmation-back-link-ajax').length > 0){
            $('#webform-56897 .js-webform-confirmation-back-link-ajax').trigger( "click" );
          }

          $('#webform-56897').find('.dla-webform-data-container').attr('data-restaurant', $(this).attr('data-restaurant'));
          $('#webform-56897').find('.dla-webform-data-container').attr('data-restaurant-nid', $(this).attr('data-nid'));
          $('[data-drupal-selector="edit-restaurant-display-name"]').val($(this).attr('data-restaurant'));
          $('[data-drupal-selector="edit-restaurant"]').val($(this).attr('data-nid'));
          $('[data-drupal-selector="edit-restaurant-nid"]').val($(this).attr('data-nid'));
          $('[data-description="dinela_menu_notification--email"]').attr('data-restaurant', $(this).attr('data-restaurant'));
          $('[data-description="dinela_menu_notification--email"]').attr('data-nid', $(this).attr('data-nid'));
          // Calculate width of text for restaurant display name and set input field to that width to get it to be inline with its prefix on the form
          var textWidth = self.calcTextWidth($('[data-drupal-selector="edit-restaurant-display-name"]').val(), $('[data-drupal-selector="edit-restaurant-display-name"]').css('font-size'), $('[data-drupal-selector="edit-restaurant-display-name"]').css('font-family'));
          $('[data-drupal-selector="edit-restaurant-display-name"]').css('width', textWidth.width);

          // Event tracking
          var props = {};
          props['event'] = 'Modal Shown';
          props['modal_id'] = "webform-56897";
          props['modal_trigger_type'] = 'Click';
          props['restaurant'] = $(this).attr('data-restaurant');
          props['nid'] = $(this).attr('data-nid');
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push(props);

        });

      });

    },

    calcTextWidth: function (pText, pFontSize, pStyle) {
      // Handy JavaScript to measure the size taken to render the supplied text;
      var lDiv = document.createElement('div');
      document.body.appendChild(lDiv);
      if (pStyle != null) {
        lDiv.style = pStyle;
      }
      lDiv.style.fontSize = "" + pFontSize;
      lDiv.style.position = "absolute";
      lDiv.style.left = -1000;
      lDiv.style.top = -1000;
      lDiv.innerHTML = pText;
      var lResult = {
        width: lDiv.clientWidth,
        height: lDiv.clientHeight
      };
      document.body.removeChild(lDiv);
      lDiv = null;
      return lResult;
    },

    mapBoxInvalidateSize: function (context) {
      // Previously, some tiles on the map were missing at larger screen size after a toggle event
      // Run this command to ensure all tiles load on Dine LA map load after map/list toggle events
      let guideMapbox = Drupal.Leaflet["leaflet-map-view-dinela-block-dinela-map"].lMap;
      guideMapbox.invalidateSize();
      // Triggering a window resize here seems to help ensure map renders correctly with all tiles loaded and at appropriate zoom
      $(window).trigger('resize');
      var evt = window.document.createEvent('UIEvents');
      evt.initUIEvent('resize', true, false, window, 0);
      window.dispatchEvent(evt);
    },

    arrayUnique: function (array) {
      var a = array.concat();
      for(var i=0; i<a.length; ++i) {
        for(var j=i+1; j<a.length; ++j) {
          if(a[i] === a[j])
            a.splice(j--, 1);
        }
      }
      return a;
    },

    totalTopElements: function () {
      // Get total height of top elements;
      var adminMenuHeight = 0
      var regionPageHeaderHeight = 0;
      var regionTabsHeight = 0;
      // Calculate height of elements of they exist
      if ($("#toolbar-bar").length > 0) {
        adminMenuHeight = $("#toolbar-bar").height() + $("#toolbar-item-administration-tray").height();
      }
      if ($(".dla-page-header").length > 0) {
        regionPageHeaderHeight = $(".dla-page-header").height();
      }
      if ($(".dla-region-tabs").length > 0) {
        regionTabsHeight = $(".dla-region-tabs").height();
      }
      return adminMenuHeight + regionPageHeaderHeight + regionTabsHeight;
    },

    targetScrollTop: function () {
      var $navbar = $('.dla-navbar_container');
      var $view = $('.view-dinela');

      if ($navbar.length && $view.length) {
        var navbarBottom = $navbar.offset().top + $navbar.outerHeight();
        var viewTop = $view.offset().top;
        var scrollOffset = viewTop - navbarBottom;

        // Get current scroll position and add offset
        var targetScrollTop = $(window).scrollTop() + scrollOffset;

        return targetScrollTop;
      } else {
        return null;
      }
    },

  };
})(jQuery, Drupal, once);
